import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  RideTextField,
  RideSelectTextField,
  RideSelect,
  RideButton,
} from "@rimac-seguros/ride-system-components";
import { useForm } from "react-hook-form";
import {
  LIST_DOCUMENT_TYPE,
  DOCUMENT_TYPE_RUC,
  getDocumentType,
} from "@/consts/listDocumentType";
import { Regex } from "@/utils/regex";
import { formatDocument } from "@/utils/formatDocument";
import { getDataConsultSoat, getDigitalId } from "@/redux/actions/consultAction";
import { useRuteHandler } from "../../hooks/useRuteHandler";
import useBreakpoint from "@/hooks/useBreakpoint";

import "./styles.scss";
import { encryptAES256 } from "@/utils/cifrate";
import { APP_KEY_ENCRYPT } from "@/utils/awsConfig";
import { sendMessageToApp } from "@/utils/helpers";
import { useEmbedded } from "@/hooks/useEmbedded";

const termsLink = "https://www.rimac.com/politica-privacidad";

const Form = (props) => {
  const {
    register,
    watch,
    reset,
    setValue,
    formState: { errors, isValid },
    trigger,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      documentType: "2",
    },
  });

  const { getDataConsultSoat, getDigitalId } = props;

  const { isEmbedded } = useSelector((state) => state.embeddedReducer);

  const { nroDocumentoApp, tipoDocumentoApp } = useEmbedded();

  const [clickOnNextButton, setClickOnNextButton] = useState(false);
  const { handleSendGoRute } = useRuteHandler(props);
  const isTablet = useBreakpoint("tablet");

  const handleCarPlate = (e) => {
    const el = e.target;
    el.value = el.value.replace(/[^a-zA-Z0-9]/g, "");
  };

  const handleInputDocument = (e) => {
    const el = e.target;
    el.value = formatDocument(watch("documentType"), el.value);
  };

  const handleNextStep = async () => {
    await trigger();
    if (!isValid || Object.keys(errors).length > 0) return;

    if (clickOnNextButton) return;
    setClickOnNextButton(true);
    const body = {
      tipoDocumento: watch("documentType"),
      numeroDocumento: watch("documentNumber"),
      placa: String(watch("carPlate")).toUpperCase(),
    };
    getDigitalId({
      tipoDocumento: watch('documentType') === "2" ? 'DNI' : watch('documentType') === "1" ? 'RUC' : 'CE',
      numeroDocumento: watch('documentNumber'),
    });
    const result = await getDataConsultSoat(body, props.onestep);
    handleSendGoRute(result, watch("carPlate"));
  };

  const handleClickTerms = (link) => {
    if (isEmbedded) {
      const message = `EMBEDDED-APP-HIPERVINCULO : {"accion": "LINK", "valor": "${link}", "mensaje": ""}`;
      const encryptedMessage = encryptAES256(message, APP_KEY_ENCRYPT);
      return sendMessageToApp(encryptedMessage);
    }
    window.open(link, "_blank", "noopener noreferrer");
  };

  useEffect(() => {
    if (isEmbedded && nroDocumentoApp && tipoDocumentoApp) {
      setValue("documentType", tipoDocumentoApp);
      setValue("documentNumber", nroDocumentoApp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmbedded]);

  return (
    <div className="hero-form">
      <RideSelectTextField
        label="Nro. de Documento"
        size="large"
        error={!!errors?.documentNumber}
        disabled={clickOnNextButton || (isEmbedded && nroDocumentoApp)}
        errorMessage={
          errors?.documentNumber?.type === "required"
            ? "Es necesario que ingreses tu Nro. de documento"
            : "Formato de documento incorrecto"
        }
      >
        <RideSelect
          {...register("documentType", { required: true })}
          options={LIST_DOCUMENT_TYPE}
          value={watch("documentType")}
          onSelect={(e) => {
            reset({ documentType: e.value, documentNumber: "" });
          }}
        />
        <RideTextField
          {...register("documentNumber", {
            required: true,
            minLength: getDocumentType(watch("documentType"))?.minLength,
            validate: () => {
              const type = watch("documentType");
              const value = watch("documentNumber");
              return type === DOCUMENT_TYPE_RUC.value
                ? String(value).startsWith("10") ||
                    String(value).startsWith("20")
                : true;
            },
          })}
          autoComplete="off"
          maxLength={getDocumentType(watch("documentType"))?.maxLength}
          onInput={handleInputDocument}
        />
      </RideSelectTextField>
      <div className="relative field-capitalize">
        <RideTextField
          {...register("carPlate", {
            required: true,
            pattern: Regex.carPlate,
          })}
          aria-required
          label="Placa"
          autoComplete="off"
          size="large"
          maxLength={8}
          disabled={clickOnNextButton}
          error={!!errors?.carPlate}
          errorMessage={
            errors?.carPlate?.type === "required"
              ? "Campo requerido"
              : "Ingresa un número de placa válido"
          }
          onInput={handleCarPlate}
        />
      </div>
      <p className="ride-sys-text-paragraph-small-default text-center">
        Al continuar acepto la&nbsp;
        <a
          onClick={() => handleClickTerms(termsLink)}
          className="underline ride-sys-text-paragraph-small-bold"
        >
          Política de Privacidad
        </a>
      </p>
      <div className="flex justify-center w-full">
        <RideButton
          onClick={handleNextStep}
          text="Consultar"
          size={isTablet ? "x-large" : "large"}
          loading={clickOnNextButton}
          fullWidth={!isTablet}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ errorApiReducer }) => {
  return {
    errorApi: errorApiReducer,
  };
};

const mapDsipatchToProps = (dispatch) => {
  return {
    getDataConsultSoat: (data, onestep) => dispatch(getDataConsultSoat(data, onestep)),
    getDigitalId: (data) => dispatch(getDigitalId(data)),
  };
};

const FormHomeR = connect(mapStateToProps, mapDsipatchToProps)(Form);

export default FormHomeR;
